import { createContext, useContext, type ReactNode } from 'react';
import { t, tf, type Language, type TranslationKey } from '../utils/i18n';

const LanguageContext = createContext<Language>('nl');

/** Zet de gekozen taal beschikbaar voor alle componenten eronder (zie useT). */
export function LanguageProvider({ language, children }: { language: Language; children: ReactNode }) {
  return <LanguageContext.Provider value={language}>{children}</LanguageContext.Provider>;
}

/** Vertaalfuncties voor de gekozen taal; zo hoeft `language` nooit als prop doorgegeven te worden. */
export function useT() {
  const language = useContext(LanguageContext);
  return {
    language,
    t: (key: TranslationKey) => t(language, key),
    tf: (key: TranslationKey, vars: Record<string, string | number>) => tf(language, key, vars),
  };
}
